import { Categories } from "@r8er/components/marketing/categories";
import { Cta } from "@r8er/components/marketing/cta";
import { Hero } from "@r8er/components/marketing/hero";
import { Layout } from "@r8er/components/marketing/layout";
import { Newsletter } from "@r8er/components/marketing/newsletter";
import { getCategories } from "@r8er/lib/config/categories";
import {
  type PrimarySector,
  PRIMARY_SECTORS,
  parsePrimarySector,
  primarySectorSlug,
} from "@r8er/lib/config/sectors";
import type { GetServerSideProps } from "next";
import Head from "next/head";

export interface CategoriesPageProps {
  activePrimarySector: PrimarySector;
}

/** Redirect the former query-string route to a canonical sector URL. */
export const getServerSideProps: GetServerSideProps = async ({ query }) => {
  return {
    redirect: {
      destination: `/categories/${primarySectorSlug(
        parsePrimarySector(query.domain ?? query.sector),
      )}`,
      permanent: true,
    },
  };
};

export function CategoriesPage({ activePrimarySector }: CategoriesPageProps) {
  const sectorLinks = PRIMARY_SECTORS.map((primarySector) => ({
    label: primarySector,
    href: `/categories/${primarySectorSlug(primarySector)}`,
    isActive: primarySector === activePrimarySector,
  }));

  return (
    <div>
      <Head>
        {/*
          One string child, not an interpolation next to literal text. React 19
          drops the children of a <title> when there is more than one and
          renders <title></title>, so `{activePrimarySector} Categories - R8ER` would
          leave this public page with no indexed title at all. Same form as
          articles/[slug].tsx.
        */}
        <title>{`${activePrimarySector} Categories - R8ER`}</title>
        <link rel="icon" href="/favicon.png" />
      </Head>

      <Layout>
        <Hero isSlim title="Categories" img="/categories-hero.png" />

        <Categories
          description="The future of health and climate will include a broad range of skills and bright ideas, many of which will fall under the categories below or a combination thereof."
          preserveSectorScroll
          sectorLinks={sectorLinks}
          visibleCategories={getCategories(activePrimarySector)}
        />

        <Cta
          title="Start your R8ER Journey Today"
          description="If you are looking for investment or looking to invest, sign up to R8ER today."
          buttonText="Get Started"
          buttonHref="/auth/signup"
          isBlue
        />

        <Newsletter />
      </Layout>
    </div>
  );
}

export default function CategoriesRedirect() {
  return null;
}
